
import Okb from "../../../assets/filled/Okb.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function OkbIcon({ className, dataTestid = "OkbIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Okb data-testid={dataTestid} className={classes} {...rest} />
  );
}
